





















import { defineComponent, watch, ref } from '@vue/composition-api';

export default defineComponent({
  props: {
    disabled: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
      default: null,
    },
    showBorder: {
      type: Boolean,
    },
    showShadow: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const expanded = ref(false);

    const handleToggle = (isExpanded: boolean) => {
      expanded.value = isExpanded;
      emit('toggle', isExpanded);
    };

    watch(
      () => props.isOpen,
      isOpen => {
        if (props.isOpen !== null) {
          expanded.value = isOpen;
        }
      },
      { immediate: true }
    );

    return {
      expanded,
      handleToggle,
    };
  },
});
